import styled from 'styled-components';
const calculateTransform = ($isOpen, $side) => {
    if ($isOpen) {
        return 'translateX(0)';
    }
    if ($side === 'right') {
        return 'translateX(100%)';
    }
    return 'translateX(-100%)';
};
export const DrawerContainer = styled.div `
  width: 100%;
  position: fixed;
  overflow: hidden;
  background-color: ${({ $backgroundColor }) => `var(--${$backgroundColor})`};
  z-index: ${({ $zIndex }) => $zIndex};
  top: ${({ $top = 0 }) => `${$top.toString()}px`};
  bottom: 0;
  right: ${({ $side }) => ($side === 'right' ? '0' : 'auto')};
  left: ${({ $side }) => ($side === 'left' ? '0' : 'auto')};
  transform: ${({ $isOpen, $side }) => calculateTransform($isOpen, $side)};
  transition: 0.3s ease-in-out;

  @media (min-width: 800px) {
    max-width: ${({ $width }) => $width || '360px'};
  }
`;
export const Backdrop = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  cursor: pointer;
  z-index: ${({ $zIndex }) => $zIndex};
`;
